// layouts/AdminLayout.tsx
import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Container } from '@mui/material';
import { Profile as ProfileModel, Account as AccountModel } from '../models';

interface AdminLayoutProps {
  profile: ProfileModel;
  account: AccountModel;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ profile, account }) => {
  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Admin Dashboard
          </Typography>
          <Typography variant="body1">
            Logged in as {profile.email}. <Link to="/apps" style={{ color: "#fff" }}>Leave Admin</Link>
          </Typography>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 4 }}>
        {/* This will render the nested routes (e.g., AdminDashboard) */}
        <Outlet />
      </Container>
    </>
  );
};

export default AdminLayout;
